import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import PerformanceApi from 'api/executive/performance.api'
import type {
  AvgRevenuePerPatientResponse,
  GetAvgRevenuePerPatientParams,
  ProcedureFilterMode,
} from 'api/executive/executive.types'

export function useAvgRevenuePerPatient(procedureFilterMode: ProcedureFilterMode = 'all') {
  return useExecutiveQuery<GetAvgRevenuePerPatientParams, AvgRevenuePerPatientResponse>(
    'performance.avg-revenue-per-patient',
    PerformanceApi.getAvgRevenuePerPatient,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        procedureId: f.procedureId ?? undefined,
        patientType: f.patientType ?? undefined,
        // Omit when 'all' so the request stays clean; server defaults to 'all'.
        procedureFilterMode: procedureFilterMode !== 'all' ? procedureFilterMode : undefined,
      }
    },
    { extraKey: procedureFilterMode }
  )
}
